import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface FirmContextState {
  activeFirmId: number | null;
  setActiveFirmId: (id: number | null) => void;
  reset: () => void;
}

export const useFirmContextStore = create<FirmContextState>()(
  persist(
    (set) => ({
      activeFirmId: null,
      setActiveFirmId: (activeFirmId) => set({ activeFirmId }),
      reset: () => set({ activeFirmId: null }),
    }),
    {
      name: 'apx-insight-firm-context',
      storage: createJSONStorage(() => localStorage),
      onRehydrateStorage: () => (state) => {
        if (state && (state.activeFirmId === 0 || (state.activeFirmId ?? 0) < 0)) {
          state.activeFirmId = null;
        }
      },
    }
  )
);
